module.exports = __webpack_public_path__ + "static/media/user.6b14b8e9.svg";